export default __webpack_public_path__ + "static/recog-0-60cdb2acac8f5e557792de3d559f2a87.png";